import React, { useState } from "react";
import { Button, Icon, Popover, Close, ModalContentButton, ModalTitle, ModalContent, ModalRoot } from "@pmi/nyx-design-system";
import slide1 from "../../assets/images/slide_1.png";
import slide2 from "../../assets/images/slide_2.png";
import slide3 from "../../assets/images/slide_3.png";
import slide4 from "../../assets/images/slide_4.png";
import slide5 from "../../assets/images/slide_5.png";

// Help code (all UI slides)
function QuickIntro() {
    const [open, setOpen] = useState(false);
    const [isIntroOpen, setIsIntroOpen] = useState(false);
    const [step, setStep] = useState(1);

    // Dummy slide JSON
    const steps = [
        { title: "1", text: "You can search any region, city, municipality, or POS from the selected market. The market can be changed using the button next to the market name.", image: slide1 },
        { title: "2", text: "Click any of the metrics available on the left panel and see it reflected on the map and table preview.", image: slide2 },
        { title: "3", text: "You can open the territory preview by selecting any of market's territories from the map.", image: slide3 },
        { title: "4", text: "You can go deeper and open a detailed view of selected territory using “Open territory map” button on right hand side panel.", image: slide4 },
        { title: "5", text: "When you're on the last/city level, use “Touchpoint”, “Recommendations” and “External data” buttons on the top to filter what's visible on the map.", image: slide5 }
    ];

    const nextStep = () => {
        if (step < steps.length) {
            setStep(step + 1);
        }
    };

    const prevStep = () => {
        if (step > 1) {
            setStep(step - 1);
        }
    };
    return (
        <>
            <div className="quick_intro">
                <Popover align="start" className="w-20" open={open} onOpenChange={setOpen} footer={<><Button size="small" onClick={() => setOpen(false)}>Maybe later</Button><Button size="small" onClick={() => setIsIntroOpen(true)}>Start introduction</Button></>}
                    data-testid="Popover" side="top" title="Quick introduction" trigger={<svg width="48" height="48" viewBox="0 0 24 24" fill="#1C74CD">
                        <circle cx="12" cy="12" r="10" fill="#1C74CD" />
                        <text x="12" y="16" textAnchor="middle" fill="white" fontSize="12px">?</text>
                      </svg>}>
                    Spend 2 min and learn the basics of Store Advisor. You can open it any time you want using the question mark button in the corner.
                </Popover>
                {isIntroOpen &&
                    <>
                        <ModalRoot open onOpenChange={setIsIntroOpen}>
                            <ModalContent>
                                <div className="d-flex justify-content-between"> 
                               <h4 className="fw-bold py-2">Quick Introduction</h4>
                               <Icon color="primary" role="button" data-testid="icon-test" name="close" size="large" className="close-icon" onClick={() => { setIsIntroOpen(false); setStep(1);}}/>
                               </div>
                                <ModalTitle>Tip {steps[step - 1].title}/5</ModalTitle>
                                <div className="d-flex ">
                                <div>{steps[step - 1].text}
                                <p className="dots-container">
                                    {steps.map((_, index) => (
                                        <span
                                            key={index}
                                            className={`dot ${index + 1 === step ? "active" : ""}`}
                                        />
                                    ))}
                                </p>
                                </div>
                                <div style={{ width: "100%", height: "200px", textAlign: "center" }}>
                                    <img src={steps[step - 1].image} alt={`Step ${steps[step - 1].title}`} style={{ maxWidth: "100%", maxHeight: "200px", objectFit: "contain" }} />
                                </div>
                                </div>
                                <ModalContentButton>
                                    {step > 1 && <Button outlined className="border-0 bg-white" onClick={prevStep}>Back</Button>}
                                    {step < steps.length ? (
                                        <Button onClick={nextStep}>Next</Button>
                                    ) : (
                                        <Close>
                                            <Button onClick={() => { setIsIntroOpen(true); setStep(1);}}>Close</Button>
                                        </Close>
                                    )}
                                </ModalContentButton>
                            </ModalContent>
                        </ModalRoot>

                    </>
                }
            </div>
        </>
    )
}

export default QuickIntro;